import { xs_languageCode } from "..";
import { getUrlPathSeo } from "./utils/getUrlPathSeo";
import { getUrlPathSeoSettings } from "./utils/getUrlPathSeoSettings";
import { parseBetsData } from './parseBetsData';
import parseJerseys from "./parseJerseys";
import { getUrlPath } from "./util/getUrlPath";
import { addZero } from './utils/addZero';
import { formatDate } from './utils/formatDate';
import { formatDateWithWeekDay } from './utils/formatDateWithWeekDay';
import { getConfiguration } from './utils/configuration';
import { getDBTimestampFromDate } from './utils/getDBTimestampFromDate';
import { getSplitDesc } from './utils/getSplitDesc';

export function enableDisableOdds(matches, minValue, maxValue) {
    matches.forEach(m => {
        m.gruppiScommessa[0].scommesse.forEach(bet => {
            bet.odds.forEach(odd => {
                if (odd.value != null) {
                    if (odd.rawValue >= minValue && odd.rawValue <= maxValue) {
                        odd.highlighted = true;
                        odd.disabled = false;
                    } else {
                        odd.disabled = true;
                        odd.highlighted = false;
                    }
                } else {
                    odd.disabled = true;
                }
            });
        });
    });
}

export function byRankingAndTime(e1, e2) {
    if (e1.timestampDB === e2.timestampDB) {
        const e1Rankings = e1.rankings;
        const e2Rankings = e2.rankings;
        if (e1Rankings.categoryRanking === e2Rankings.categoryRanking) {
            return e1Rankings.tournamentRanking - e2Rankings.tournamentRanking;
        } else {
            return e1Rankings.categoryRanking - e2Rankings.categoryRanking;
        }
    } else {
        return e1.timestampDB.localeCompare(e2.timestampDB);
    }

}

export function parseFavoriteOdds(data) {
    const conf = getConfiguration();
    const values = Array.from(new Set(conf.foc.ods)).sort((a, b) => a - b);
    const events = [];
    const eventsBySport = new Map();
    let sports = [];

    const currentTimestamp = getDBTimestampFromDate(new Date());
    Object.values(data.evs).forEach(m => {
        // Process only the matches referring to future dates/times
        if (m.ts.localeCompare(currentTimestamp) > 0) {
            const desc = m.dsl[xs_languageCode];
            const sportId = m.is;
            const sportDesc = data.dsps[sportId][xs_languageCode];
            const tournamentDesc = `${data.dcts[m.ic][xs_languageCode]} - ${data.dtns[m.it][xs_languageCode]}`;
            const [team1, team2] = getSplitDesc(desc);
            const uniqueId = `${sportId}_${m.ic}_${m.it}_${m.bid}`;
            const matchData = {
                sportRef: sportId,
                pal: m.p,
                avv: m.a,
                id: m.bid,
                desc,
                uniqueId,
                alias: m.al,
                sportDesc,
                tournamentDesc,
                timestamp: m.ts,
                tournamentRef : m.it,
                seoSettings: m.seo,
                seoSettingsAdds: m.seoa,
                urlPath: getUrlPath({uniqueId: `${sportId}_${m.ic}_${m.it}`, urlPath: `${sportDesc}/${tournamentDesc}`}, m, desc),
                urlPathSeo: getUrlPathSeo({...m,seoSettings:m.seo}),
                urlPathSeoSettings: getUrlPathSeoSettings({...m,seoSettingsAdds:m.seoa})
            };
            const betsData = parseBetsData(matchData, [m.oa], m.oa, m.scs, false, true);
            const date = formatDate(m.ts);
            const match = {
                id: m.bid,
                alias: m.al,
                pal: m.p,
                avv: m.a,
                desc,
                team1,
                team2,
                date: `${addZero(date.day)}/${addZero(date.month)}`,
                fullDate: formatDateWithWeekDay(m.ts).dayMonthYear,
                time: formatDate(m.ts).time,
                timestampDB: m.ts,
                isLive: m.lv,
                sportRef: sportId,
                categoryRef: m.ic,
                sportDesc: matchData.sportDesc,
                tournamentDesc,
                // icoTournament : tournamentIcoById[m.it],
                tournamentRef: m.it,
                uniqueId,
                favorite: false,
                plus: m.pl,
                openAggregata: m.oa,
                openMacrogruppo: m.om,
                rankings: {
                    categoryRanking: data.rkc[m.ic],
                    tournamentRanking: data.rkt[m.it]
                },
                jerseys: parseJerseys(m.j, sportId),
                urlPath: getUrlPath({uniqueId: `${sportId}_${m.ic}_${m.it}`, urlPath: `${matchData.sportDesc}/${tournamentDesc}`}, m, desc),
                urlPathSeo: getUrlPathSeo(matchData),
                urlPathSeoSettings: getUrlPathSeoSettings(matchData)
            };
            Object.assign(match, betsData);

            // Remove bets without odds and set which odds filter apply to the event
            const filters = new Map();
            const betsByFilter = new Map();
            const agg = betsData.gruppiScommessa[0];
            agg.scommesse.forEach(bet => {
                const betId = `${bet.id}_${bet.handicap}`;
                
                for (let i = 0; i < values.length; i++) {
                    const o1 = values[i];
                    for (let j = i; j < values.length; j++) {
                        const o2 = values[j];
                        for (let i = 0; i < bet.odds.length; i++) {
                            const odd = bet.odds[i];
                            if (odd.rawValue != null && odd.rawValue >= o1 && odd.rawValue <= o2) {
                                let filterKey = `${o1}_${o2}`;
                                if (filters.has(betId)) {
                                    let yo = filters.get(betId);
                                    if (!yo.has(filterKey)) {
                                        yo.add(filterKey);
                                    }
                                } else {
                                    let k = new Set();
                                    k.add(filterKey);
                                    filters.set(betId, k);
                                }
        
                                if (!betsByFilter.has(filterKey)) {
                                    betsByFilter.set(filterKey, new Map());
                                }
                                const betsMap = betsByFilter.get(filterKey);
                                if (!betsMap.has(bet.id)) {
                                    betsMap.set(bet.id, []);
                                }
                                betsMap.get(bet.id).push(bet);
        
                                break;
                            }
                        }
                    }
                }
            });

            match.filters = filters;
            match.betsByFilter = betsByFilter;

            events.push(match);
            if (!eventsBySport.has(sportId)) {
                eventsBySport.set(sportId, []);
                sports.push({
                    id: sportId,
                    descrizione: data.dsps[sportId][xs_languageCode],
                    iconClass: data.icsp[sportId] || null,
                });
            }
            eventsBySport.get(sportId).push(match);
        }
    });
    sports = sports.sort((a, b) => data.rks[a.id] - data.rks[b.id]);

    return {
        events,
        eventsBySport,
        sports
    };
}